export const EDD_INDICATOR_LABELS = {
  lifeNb:
    "5 or more Life/ILAS new business transactions in the last 12 months",
  lifeLumpSum:
    "Life/ILAS lump-sum premium (single premium plus annual premium equivalent) exceeds HKD 3M",
  subscriptionHigh: "Subscription amount exceeds HKD 2M",
  subscriptionFrequent:
    "More than 5 subscriptions and subscription amount exceeds HKD 1M",
  withdrawalTop5: "Withdrawal is in this month's top 5 amounts",
};

export const activeEddIndicators = (summary) => {
  const flags = summary?.flags || {};
  return Object.keys(EDD_INDICATOR_LABELS).filter((key) => flags[key]);
};

export const openEddTab = () => {
  window.dispatchEvent(
    new CustomEvent("mbid:open-form-tab", {
      detail: { tabsKey: "main-tab", value: "EDD" },
    })
  );
};
